import React from "react";

interface FormSectionProps {
  title: string;
  children: React.ReactNode;
  className?: string;
}

export default function FormSection({
  title,
  children,
  className = "",
}: FormSectionProps) {
  return (
    <div className={`flex flex-col ${className}`}>
      <span className="text-lg font-semibold leading-none text-gray-font mb-3">
        {title}
      </span>
      {children}
    </div>
  );
}
